/* eslint-disable no-undef */
import React, { useEffect, useRef, useState } from 'react'
import { useDrag, useDrop } from 'react-dnd'
// import { generateUniqueId } from '../../Global'
import { RhyBusInputText, RhyBusCustomSelect, RhyBusTextArea, RhyBusInputCheck, RhyBusDatePicker, RhyBusLabel, RhyBusSwitch } from '@rhybus/form-controls'
import { RhyBusButton } from '@rhybus/button'
import { RhyBusFileUpload } from '@rhybus/file-upload'
import { RhybusPeoplePicker } from '@rhybus/people-picker'
import { RhyBusRichText } from '@rhybus/richtext'
// import FileUpload from '../../components/upload/upload-file'
// import Buttons from '../../components/buttons/buttons'
import { useFileContext } from '../fileContext/fileContext'
import { getButtonPositionClass, getButtonColClass, formatPhoneNumber, buildUploadHint } from './element-options'
// import { cleanAndFormatHTML } from '../Global'

interface DraggbleChildComponentProps {
    child: any;
    index: number;
    moveChild: (dragIndex: number, hoverIndex: number) => void;
    selectedChildId: string | null;
    handleSelectChild: any;
    formSettings: any
    setSelectedChildId: React.Dispatch<React.SetStateAction<string | null>>
    setSelectedWholeRowId: React.Dispatch<React.SetStateAction<string | null>>
    selectedWholeRowId: string | null
    containersData: { id: string, rowData: { id: string; childData: { id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean }[] }[] }[],
    rowId: any,
    selectedRowId: string | undefined
    childrenData: any,
    dynamicContainerId: any,
    isSelected: boolean;
    layout: number[] | null;
    setSelectChilds?: any
    setContainersData: any
    setSelectedContainer: any
    containerId: any,
    setSelectedType: React.Dispatch<React.SetStateAction<string | null>>
    setSelectedSubChild: React.Dispatch<React.SetStateAction<string | null>>
    getChildSelects: any
    setSelectedLayout: React.Dispatch<any>
    selectedLayout: any,
    setDraggingChildId?: React.Dispatch<React.SetStateAction<string | null>>

}

const DraggableChildComponent: React.FC<DraggbleChildComponentProps> = (props) => {
    const { selectedChildId, setSelectedChildId, rowId, selectedRowId, dynamicContainerId, containersData,
        formSettings, setSelectChilds, setContainersData, containerId, child, moveChild, index, handleSelectChild, setSelectedType, setSelectedSubChild, getChildSelects, selectedLayout, setDraggingChildId } = props
    const ref = useRef<HTMLDivElement>(null)
    const [selectedChildLabel, setSelectedChildLabel] = useState<string>('')
    const [selectedSubButtonId, setSelectedSubButtonId] = useState<string | null>(null)
    const { setFormPageComponents, } = useFileContext()
    // const [{ isDragging }, drag] = useDrag({
    //     type: 'CHILDS',
    //     item: () => ({ index, id: child.id }),

    //     collect: (monitor) => ({
    //         isDragging: monitor.isDragging(),
    //     }),
    // })
    const [{ isDragging }, drag] = useDrag({
        type: 'CHILDS',
        item: () => {
            return { index, id: child.id, sourceRowId: rowId, sourceContainerId: dynamicContainerId }
        },
        collect: (monitor) => ({
            isDragging: !monitor.isDragging(),
        }),
    })
    const [, drop] = useDrop({
        accept: 'CHILDS',
        hover: (draggedItem: { index: number; id: string; sourceRowId?: string; sourceContainerId?: string }) => {
            if (draggedItem.sourceRowId === rowId) {
                // Same row — reorder in place
                if (draggedItem.index !== index) {
                    moveChild(draggedItem.index, index)
                    draggedItem.index = index
                }
            } else {
                // Cross-row — splice element into this row at the hovered index
                const childId = draggedItem.id
                setContainersData((prevData: any) => {
                    let movedChild: any = null
                    const step1 = prevData.map((container: any) => ({
                        ...container,
                        rowData: container.rowData.map((row: any) => {
                            if (row.id === draggedItem.sourceRowId) {
                                movedChild = row.childData.find((c: any) => c.id === childId)
                                return { ...row, childData: row.childData.filter((c: any) => c.id !== childId) }
                            }
                            return row
                        })
                    }))
                    if (!movedChild) return prevData
                    return step1.map((container: any) => ({
                        ...container,
                        rowData: container.rowData.map((row: any) => {
                            if (row.id === rowId) {
                                const updated = [...row.childData]
                                updated.splice(index, 0, movedChild)
                                return { ...row, childData: updated }
                            }
                            return row
                        })
                    }))
                })
                // Mark item as belonging to this row so further hover treats it as same-row
                draggedItem.sourceRowId = rowId
                draggedItem.sourceContainerId = dynamicContainerId
                draggedItem.index = index
            }
        },
    })
    useEffect(() => {
        if (ref.current) {
            drag(ref.current)
            drop(ref.current)
            console.log('drag drop attached', child.id) // check if this logs
        }
    }, [drag, drop])
    // Track drag state and highlight dragged child
    useEffect(() => {
        console.log('isDragging changed:', isDragging, child.id)
        if (isDragging) {
            setDraggingChildId?.(child.id)
            handleSelectChild(child.id, dynamicContainerId, rowId)
            setSelectedChildId(child.id)
        } else {
            setDraggingChildId?.(null)
        }
    }, [isDragging, child.id, setDraggingChildId])

    const updateComponents = () => {
        // Serialize schema directly to JSX to preserve labels, isMandatory, isInfo, and component types
        const usedTypes = new Set<string>()

        const serializeChild = (ch: any, colClass: string): string => {
            const isMandatoryJsx = ch.isMandatory ? '{true}' : '{false}'
            const label: string = ch.label || ''
            const infoProp = label ? ` info="${label}"` : ''
            const id: string = ch.id || ''
            const placeholder: string = ch.placeholder || `Enter ${label}`

            switch (ch.type) {
                case 'Input':
                case 'text':
                case 'email':
                case 'number':
                case 'phone':
                case 'search':
                case 'currency':
                    usedTypes.add('RhyBusInputText')
                    return `<div className="${colClass}">\n          <RhyBusInputText id="input-${id}" name="${label}" label="${label}" placeholder="${placeholder}" isMandatory=${isMandatoryJsx}${infoProp} />\n        </div>`
                case 'Radio':
                case 'radio':
                    usedTypes.add('RhyBusInputCheck')
                    usedTypes.add('RhyBusLabel')
                    return `<div className="${colClass}">\n          <div className="form-vertical">\n            <RhyBusLabel htmlFor="radio-${id}" label="${label}" isMandatory=${isMandatoryJsx}${infoProp} />\n            <div className="d-flex gap-3">\n              <RhyBusInputCheck id="radio-${id}-yes" name="${id}" type="radio" label="Yes" />\n              <RhyBusInputCheck id="radio-${id}-no" name="${id}" type="radio" label="No" />\n            </div>\n          </div>\n        </div>`
                case 'checkbox':
                    usedTypes.add('RhyBusInputCheck')
                    return `<div className="${colClass}">\n          <RhyBusInputCheck id="inputcheck-${id}" name="${label}" label="${label}" isMandatory=${isMandatoryJsx}${infoProp} />\n        </div>`
                case 'Select':
                    usedTypes.add('RhyBusCustomSelect')
                    return `<div className="${colClass}">\n          <RhyBusCustomSelect id="select-${id}" name="${label}" label="${label}" placeholder="${placeholder || `Select ${label}`}" isMandatory=${isMandatoryJsx}${infoProp} options={[]} />\n        </div>`
                case 'DatePicker':
                    usedTypes.add('RhyBusDatePicker')
                    usedTypes.add('RhyBusLabel')
                    return `<div className="${colClass}">\n          <div className="form-vertical">\n            <RhyBusLabel htmlFor="date-${id}" label="${label}" isMandatory=${isMandatoryJsx}${infoProp} />\n            <RhyBusDatePicker id="date-${id}" placeholder="MM/DD/YYYY" isMandatory=${isMandatoryJsx} mode="date" />\n          </div>\n        </div>`
                case 'Textarea':
                    usedTypes.add('RhyBusTextArea')
                    return `<div className="${colClass}">\n          <RhyBusTextArea id="textarea-${id}" name="${label}" label="${label}" placeholder="${placeholder}" isMandatory=${isMandatoryJsx}${infoProp} rows={5} />\n        </div>`
                case 'RichText':
                    usedTypes.add('Richtext')
                    return `<div className="${colClass}">\n          <Richtext label="${label}" placeholder="${placeholder}" isMandatory=${isMandatoryJsx} inputProps={{id:"richtext-${id}"}} formClassName="form-vertical" />\n        </div>`
                case 'uploadfile':
                    usedTypes.add('RhyBusFileUpload')
                    return `<div className="${colClass}">\n          <RhyBusFileUpload label="${label || 'Attach File(s)'}" hint="Upload the files which are in the .png, .jpeg, .xlsx,.txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25MB. Limit is up to 10 files per screen." note="Screenshots need to be saved locally before uploading into system." mandatory=${isMandatoryJsx}${infoProp} />\n        </div>`
                case 'PeoplePicker': {
                    usedTypes.add('RhybusPeoplePicker')
                    usedTypes.add('RhyBusToolTip')
                    const mandatorySpan = ch.isMandatory ? '\n              <span className="mandatory ms-1">*</span>' : ''
                    const tooltipBlock = infoProp ? `\n              <RhyBusToolTip content="${label}" placement="top">\n                <span className="icon-rb-info ms-1"></span>\n              </RhyBusToolTip>` : ''
                    return `<div className="${colClass}">\n          <div className="sppeoplepicker">\n            <label htmlFor="people-picker-input" className="">\n              ${label}${mandatorySpan}${tooltipBlock}\n            </label>\n            <RhybusPeoplePicker\n              onSelect={(person: any) => {}}\n              className="d-flex flex-column mt-1"\n              onChange={() => {}}\n              peoplePickerData={[]}\n            />\n          </div>\n        </div>`
                }
                case 'Switch':
                    usedTypes.add('RhyBusSwitch')
                    return `<div className="${colClass}">\n          <RhyBusSwitch id="switch-${id}" label="${label}" checked={false} onChange={() => {}} isMandatory=${isMandatoryJsx}${infoProp} />\n        </div>`
                case 'Button':
                    usedTypes.add('RhyBusButton')
                    return `<div className="${colClass}">\n          <RhyBusButton label="${label}" />\n        </div>`
                case 'SectionHeader':
                    return `<div className="${colClass}">\n          <div className="w-100" style={{backgroundColor:'#EEF0FF',borderRadius:'6px',padding:'8px 12px'}}>${label}</div>\n        </div>`
                case 'ContractDurationHeader':
                    usedTypes.add('RhyBusButton')
                    return `<div className="${colClass}">\n          <div className="d-flex align-items-center justify-content-between whitetext w-100" style={{backgroundColor:'#434D8A',borderTopLeftRadius:'9px',borderTopRightRadius:'9px',padding:'8px 16px'}}>\n            ${label}\n            <RhyBusButton variant="text" label="Add" leftIcon="icon-rb-add font-12 whitetext" />\n          </div>\n        </div>`
                case 'SubSectionHeader':
                    return `<div className="${colClass}">\n          <div className="w-100" style={{backgroundColor:'#EFF7FF',color:'#004993',borderRadius:'6px',padding:'8px 12px'}}>${label}</div>\n        </div>`
                default:
                    return `<div className="${colClass}"></div>`
            }
        }

        const formattedContent = containersData.map((container: any) => {
            const rows = container.rowData.map((row: any) => {
                const layout = selectedLayout[row.id]
                const children = row.childData.map((ch: any, idx: number) => {
                    const colNum = layout ? layout[idx % layout.length] : 12
                    const colClass = colNum === 20
                        ? `col-12 col-md-6 col-lg-${colNum}per`
                        : `col-12 col-md-6 col-lg-${colNum}`
                    return serializeChild(ch, colClass)
                }).join('\n        ')
                return `<div id="${row.id}" className="row p-relative g-2">\n        ${children}\n      </div>`
            }).join('\n      ')
            return `<div id="${container.id}" className="row g-2">\n      ${rows}\n    </div>`
        }).join('\n    ')

        const formControls = ['RhyBusInputText', 'RhyBusCustomSelect', 'RhyBusTextArea', 'RhyBusInputCheck', 'RhyBusDatePicker', 'RhyBusLabel', 'RhyBusSwitch']
            .filter(c => usedTypes.has(c))
        const importLines: string[] = ['import React from \'react\'']
        if (formControls.length) importLines.push(`import { ${formControls.join(', ')} } from '@rhybus/form-controls'`)
        if (usedTypes.has('RhyBusButton')) importLines.push('import { RhyBusButton } from \'@rhybus/button\'')
        if (usedTypes.has('RhyBusFileUpload')) importLines.push('import { RhyBusFileUpload } from \'@rhybus/file-upload\'')
        if (usedTypes.has('RhybusPeoplePicker')) importLines.push('import { RhybusPeoplePicker } from \'@rhybus/people-picker\'')
        if (usedTypes.has('RhyBusToolTip')) importLines.push('import { RhyBusToolTip } from \'@rhybus/tooltip\'')
        if (usedTypes.has('Richtext')) importLines.push('import Richtext from \'./richtext\'')

        const reactComponentContent = `${importLines.join('\n')}

const Form: React.FC = () => {
  return (
    <div className="container">
    ${formattedContent}
    </div>
  )
}

export default Form`.trim()

        setFormPageComponents(reactComponentContent)
    }

    useEffect(() => {
        updateComponents()
    }, [containersData, selectedLayout])

    let childCounter = 0
    const generateUniqueId = (prefix: string) => `${prefix}-${Date.now()}-${childCounter++}`

    const renderChildComponent = (child: { id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean; position: string; placeholder: string | null; readonly: boolean | null; disabled: boolean | null; options?: any[]; variant?: 'primary' | 'secondary'; size?: 'xs' | 'sm' | 'md' | 'lg'; leftIcon?: string; rightIcon?: string; buttonClassName?: string; subChild?: any; className?: string; value?: string }) => {
        switch (child.type) {
            case 'Radio':
            case 'radio': {
                const rc = child as any
                const radioLabel = rc?.label || ''
                const radioId = rc?.id || ''
                const radioOpts: string[] = rc?.isGroup && rc?.options?.length ? rc.options.map((o: any) => o.label) : ['Yes', 'No']
                const isRadioGroup = rc?.isGroup && rc?.options?.length
                return (
                    <div className={`${getButtonColClass(rc?.checkPosition)} w-100 h-100`}>
                        <div className={getButtonPositionClass(rc?.checkPosition) || ''}>
                            {isRadioGroup ? (
                                <fieldset className="rb-option-group">
                                    <legend className="">
                                        {radioLabel}{rc?.isMandatory && <span className="rb-label-mandatory" aria-hidden="true"> *</span>}
                                        {rc?.isInfo && radioLabel && <RhyBusLabel htmlFor={`radio-${radioId}`} label="" info={radioLabel} />}
                                    </legend>
                                    <div className="d-flex gap-3 flex-wrap">
                                        {radioOpts.map(opt => (
                                            <RhyBusInputCheck key={opt} id={`radio-${radioId}-${opt.toLowerCase().replace(/\s+/g, '-')}`} name={radioId} type="radio" label={opt} />
                                        ))}
                                    </div>
                                </fieldset>
                            ) : (
                                <div className="form-vertical">
                                    <RhyBusLabel
                                        htmlFor={`radio-${radioId}`}
                                        label={radioLabel}
                                        isMandatory={rc?.isMandatory ?? false}
                                        {...(rc?.isInfo && radioLabel ? { info: radioLabel } : {})}
                                    />
                                    <div className="d-flex gap-3 flex-wrap">
                                        {radioOpts.map(opt => (
                                            <RhyBusInputCheck key={opt} id={`radio-${radioId}-${opt.toLowerCase().replace(/\s+/g, '-')}`} name={radioId} type="radio" label={opt} />
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )
            }
            case 'checkbox': {
                const cc = child as any
                if (cc?.isGroup && cc?.options?.length) {
                    return (
                        <div className={`${getButtonColClass(cc?.checkPosition)} w-100 h-100`}>
                            <div className={getButtonPositionClass(cc?.checkPosition) || ''}>
                                <fieldset className="rb-option-group">
                                    <legend className="">
                                        {cc?.label || 'Label Name'}{cc?.isMandatory && <span className="rb-label-mandatory" aria-hidden="true"> *</span>}
                                        {cc?.isInfo && cc?.label && <RhyBusLabel htmlFor={`checkbox-group-${cc?.id}`} label="" info={cc.label} />}
                                    </legend>
                                    <div className="d-flex gap-3 flex-wrap">
                                        {cc.options.map((opt: any) => (
                                            <RhyBusInputCheck key={opt.label} id={`checkbox-${cc?.id}-${opt.label.toLowerCase().replace(/\s+/g, '-')}`} name={cc?.id} type="checkbox" label={opt.label} />
                                        ))}
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    )
                }
                return (
                    <div className={`${getButtonColClass(cc?.checkPosition)} w-100 h-100`}>
                        <div className={getButtonPositionClass(cc?.checkPosition) || ''}>
                            <RhyBusInputCheck
                                id={cc?.id ? `inputcheck-${cc.id}` : 'LabelName'}
                                name={cc?.id}
                                type="checkbox"
                                label={cc?.label || 'Label Name'}
                                isMandatory={cc?.isMandatory ?? false}
                                {...(cc?.isInfo && cc?.label ? { info: cc.label } : {})}
                            />
                        </div>
                    </div>
                )
            }
            case 'Input':
            case 'text':
            case 'email':
            case 'number':
            case 'phone':
            case 'search':
            case 'currency':
                if (child?.className === 'content-block-item') {
                    const cb = child as any
                    return (
                        <div
                            className="content-block-item"
                            style={{
                                backgroundColor: cb.bgColor || undefined,
                                color: cb.cbFontColor || undefined,
                                border: cb.cbBorder || undefined,
                                fontSize: cb.cbFontSize || undefined,
                                fontWeight: cb.cbFontWeight || undefined,
                                padding: cb.cbPadding || '8px',
                                borderRadius: cb.cbBorderRadius || undefined,
                            }}
                        >
                            <textarea
                                value={cb.value || ''}
                                placeholder="Enter content..."
                                rows={1}
                                style={{ width: '100%', background: 'transparent', border: 'none', outline: 'none', resize: 'none', fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit', padding: 0, fontFamily: 'inherit', overflow: 'hidden', height: 'auto', display: 'block' }}
                                onInput={(e) => {
                                    const el = e.currentTarget
                                    el.style.height = 'auto'
                                    el.style.height = el.scrollHeight + 'px'
                                }}
                                onChange={(e) => {
                                    const newValue = e.target.value
                                    setContainersData((prev: any) => prev.map((container: any) => ({
                                        ...container,
                                        rowData: container.rowData.map((row: any) => ({
                                            ...row,
                                            childData: row.childData.map((c: any) =>
                                                c.id === child.id ? { ...c, value: newValue } : c
                                            )
                                        }))
                                    })))
                                }}
                            />
                        </div>
                    )
                }
                {
                    const c = child as any
                    const effectiveIconRight = c?.iconRight ?? (child?.type === 'search')
                    const hasLeft = !!c?.iconLeft
                    const hasRight = !!effectiveIconRight
                    const hasIcons = hasLeft || hasRight
                    const iconLeftClass = c?.customIconLeft || ''
                    const iconRightClass = c?.customIconRight || (child?.type === 'search' ? 'icon-rb-search' : '')
                    const sizeStr = c?.inputSize || 'md'
                    const iconPadClass = [hasLeft ? 'icon-left-gap' : '', hasRight ? 'icon-right-gap' : ''].filter(Boolean).join(' ')
                    const baseClassName = `${formSettings.formsize.value || ''} ${formSettings.fontcolor.value || ''} ${formSettings.fontsize.value || ''}`.trim()
                    const iconStyle: React.CSSProperties = { position: 'absolute', bottom: 0, width: 36, height: 'var(--rb-form-height, 38px)', display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none', color: 'var(--rb-form-border-color-focus, #273CC2)', fontSize: 14 }
                    const inputEl = (
                        <RhyBusInputText
                            id={child?.id ? `input-${child.id}` : 'LabelName'}
                            name={child?.label ? child?.label : ''}
                            type={child?.type === 'Input' ? 'text' : child?.type === 'phone' ? 'tel' : child?.type === 'currency' ? 'currency' : (child?.type || 'text')}
                            className={`${baseClassName} ${iconPadClass}`.trim()}
                            placeholder={child?.placeholder ? child?.placeholder : child?.label ? `Enter ${child?.label}` : ''}
                            label={child?.label ? child?.label : ''}
                            isMandatory={child?.isMandatory ? child?.isMandatory : false}
                            {...(child?.isInfo && child?.label ? { info: child.label } : {})}
                            {...(c?.inputSize ? { size: c.inputSize as any } : {})}
                            {...(c?.formlayout ? { formlayout: c.formlayout as any } : {})}
                            onChange={child?.type === 'phone' ? (e: any) => {
                                if (e?.target) e.target.value = formatPhoneNumber(e.target.value)
                            } : undefined}
                            {...(c?.maxLength != null ? { maxLength: c.maxLength } : child?.type === 'phone' ? { maxLength: 17 } : {})}
                            {...(c?.min != null ? { min: c.min } : {})}
                            {...(c?.max != null ? { max: c.max } : {})}
                            {...(child?.type === 'currency' && c?.currency ? { currency: c.currency } : {})}
                            {...(child?.type === 'currency' && c?.decimalPlaces != null ? { decimalPlaces: c.decimalPlaces } : {})}
                            wrapperClassName={child?.type === 'search' ? 'rb-search-input' : ''}
                            iconLeft={false}
                            iconRight={false}
                            {...(c?.maxCount != null ? { maxCount: c.maxCount } : {})}
                            {...(c?.inline ? { inline: c.inline } : {})}
                            {...(c?.inlineType ? { inlineType: c.inlineType as any } : {})}
                            {...(c?.isBadge ? { isBadge: c.isBadge, count: 0 } : {})}
                            {...(c?.autoComplete ? { autoComplete: c.autoComplete } : {})}
                        />
                    )
                    return (
                    <div className={child?.subChild?.length > 0 ? 'd-flex align-items-center' : ''}>
                        {hasIcons ? (
                            <div className={`rb-form-size-${sizeStr}`} style={{ position: 'relative', flex: 1 }}>
                                {inputEl}
                                {hasLeft && iconLeftClass && <span aria-hidden style={{ ...iconStyle, left: 0 }}><span className={iconLeftClass} /></span>}
                                {hasRight && iconRightClass && <span aria-hidden style={{ ...iconStyle, right: 0 }}><span className={iconRightClass} /></span>}
                            </div>
                        ) : inputEl}
                        {child?.subChild && child?.subChild?.length > 0 && child?.subChild?.map((subChild: { id: any; type: any; label: any }) => (
                            <>
                                {(
                                    <RhyBusInputCheck
                                        id={subChild?.id ? `inputcheck-${subChild.id}` : 'LabelName'}
                                        name={subChild?.type ? subChild?.type : 'Radio'}
                                        label={subChild?.label}
                                        type={subChild?.type ? subChild?.type : 'Radio'}
                                        className='ms-auto me-1 color-primary input'
                                        onChange={() => {
                                            setSelectedSubChild(subChild?.id)
                                            setSelectedType(subChild?.type)
                                            getChildSelects(subChild.id, dynamicContainerId, rowId, child?.id)
                                        }}
                                    />)}
                            </>
                        ))}
                    </div>)
                }
            case 'Select': {
                const sc = child as any
                return <RhyBusCustomSelect
                    id={child?.id ? `select-${child.id}` : 'LabelName'}
                    name={child?.label ? child?.label : 'Label Name'}
                    label={child?.label ? child?.label : 'Label Name'}
                    className={`${formSettings.formsize.value ? formSettings.formsize.value : ''} ${formSettings.borderradius.value ? formSettings.borderradius.value : ''} ${formSettings.bordertype.value ? formSettings.bordertype.value : ''} ${formSettings.bordercolor.value ? formSettings.bordercolor.value : ''}`}
                    isMandatory={child?.isMandatory ? child?.isMandatory : false}
                    {...(child?.isInfo && child?.label ? { info: child.label } : {})}
                    placeholder={child?.placeholder ? child?.placeholder : child?.label ? `Select ${child?.label}` : 'Select'}
                    options={child?.options ?? []}
                    {...(sc?.isMulti ? { isMulti: true } : {})}
                    {...(sc?.inputSize ? { size: sc.inputSize } : {})}
                    {...(sc?.formlayout ? { formlayout: sc.formlayout } : {})}
                    {...(sc?.isBadge ? { isBadge: true, count: 0 } : {})}
                    {...(sc?.maxCount != null ? { maxCount: sc.maxCount } : {})}
                    {...(sc?.inline ? { inline: sc.inline } : {})}
                    {...(sc?.inlineType ? { inlineType: sc.inlineType as any } : {})}
                />
            }
            // case 'Date':
            case 'DatePicker': {
                const dc = child as any
                return (
                    <RhyBusDatePicker
                        id={child?.id ? `date-${child.id}` : 'LabelName'}
                        label={child?.label || 'Label Name'}
                        placeholder={child?.placeholder || 'MM/DD/YYYY'}
                        isMandatory={child?.isMandatory ?? false}
                        {...(child?.isInfo && child?.label ? { info: child.label } : {})}
                        mode={(dc?.mode ?? 'date') as any}
                        formlayout={dc?.formlayout || 'vertical'}
                        {...(dc?.minDate ? { minDate: new Date(dc.minDate) } : {})}
                        {...(dc?.maxDate ? { maxDate: new Date(dc.maxDate) } : {})}
                        onOpenChange={() => {}}
                        {...(dc?.isBadge ? { isBadge: true, count: 0 } : {})}
                        {...(dc?.maxCount != null ? { maxCount: dc.maxCount } : {})}
                        {...(dc?.inline ? { inline: dc.inline } : {})}
                        {...(dc?.inlineType ? { inlineType: dc.inlineType as any } : {})}
                    />
                )
            }

            case 'PeoplePicker': {
                const pp = child as any
                return (
                    <div className={`${getButtonColClass(pp?.checkPosition)} w-100 h-100`}>
                        <div className={getButtonPositionClass(pp?.checkPosition) || ''}>
                            <div className="form-vertical">
                                <RhyBusLabel
                                    htmlFor={pp?.id ? `peoplepicker-${pp.id}` : 'LabelName'}
                                    label={pp?.label || 'Label Name'}
                                    isMandatory={pp?.isMandatory ?? false}
                                    labelClassName=""
                                    {...(pp?.isInfo && pp?.label ? { info: pp.label, tooltipPlacement: (pp?.position || 'top') as any } : {})}
                                />
                                <RhybusPeoplePicker
                                    id={pp?.id ? `peoplepicker-${pp.id}` : 'LabelName'}
                                    peoplePickerData={[]}
                                    onSelect={() => {}}
                                    onChange={() => {}}
                                    {...(pp?.displayText ? { displayText: pp.displayText } : {})}
                                    {...(pp?.placeholder ? { placeholder: pp.placeholder } : {})}
                                    iconLeft={pp?.iconLeft ?? false}
                                    iconRight={pp?.iconRight ?? false}
                                    {...(pp?.customIcon ? { customIcon: pp.customIcon } : {})}
                                    className={`${formSettings.formsize.value || ''} ${formSettings.borderradius.value || ''} ${formSettings.bordertype.value || ''} ${formSettings.bordercolor.value || ''}`.trim()}
                                />
                            </div>
                        </div>
                    </div>
                )
            }

            case 'Switch': {
                const sw = child as any
                return (
                    <div className={`${getButtonColClass(sw?.checkPosition)} w-100 h-100`}>
                        <div className={getButtonPositionClass(sw?.checkPosition) || ''}>
                            <div className="form-vertical">
                                <RhyBusLabel
                                    htmlFor={sw?.id ? `switch-${sw.id}` : 'LabelName'}
                                    label={sw?.label || 'Label Name'}
                                    isMandatory={sw?.isMandatory ?? false}
                                    labelClassName=""
                                    {...(sw?.isInfo && sw?.label ? { info: sw.label, tooltipPlacement: (sw?.position || 'top') as any } : {})}
                                />
                                <RhyBusSwitch
                                    id={sw?.id ? `switch-${sw.id}` : 'LabelName'}
                                    checked={false}
                                    onChange={() => {}}
                                    disabled={sw?.disabled ?? false}
                                    {...(sw?.inputSize ? { size: sw.inputSize as any } : {})}
                                    {...(sw?.firstLabel ? { firstLabel: sw.firstLabel } : {})}
                                    {...(sw?.secondLabel ? { secondLabel: sw.secondLabel } : {})}
                                    {...(sw?.isBadge ? { isBadge: true, count: 0 } : {})}
                                    {...(sw?.maxCount != null ? { maxCount: sw.maxCount } : {})}
                                    {...(sw?.inline ? { inline: sw.inline } : {})}
                                    {...(sw?.inlineType ? { inlineType: sw.inlineType as any } : {})}
                                />
                            </div>
                        </div>
                    </div>
                )
            }

            case 'Textarea': {
                const ta = child as any
                return (
                    <RhyBusTextArea
                        id={ta?.id ? `textarea-${ta.id}` : 'LabelName'}
                        name={ta?.label || 'Label Name'}
                        label={ta?.label || 'Label Name'}
                        placeholder={ta?.placeholder || (ta?.label ? `Enter ${ta.label}` : 'Label Name')}
                        rows={ta?.rows ?? 5}
                        isMandatory={ta?.isMandatory ?? false}
                        disabled={ta?.disabled ?? false}
                        labelClassName=""
                        {...(ta?.isInfo && ta?.label ? { info: ta.label, tooltipPlacement: (ta?.position || 'top') as any } : {})}
                        {...(ta?.inputSize ? { size: ta.inputSize as any } : {})}
                        {...(ta?.formlayout ? { formlayout: ta.formlayout as any } : {})}
                        {...(ta?.maxLength != null ? { maxLength: ta.maxLength } : {})}
                        {...(ta?.isBadge ? { isBadge: true, count: 0 } : {})}
                        {...(ta?.maxCount != null ? { maxCount: ta.maxCount } : {})}
                        {...(ta?.inline ? { inline: ta.inline } : {})}
                        {...(ta?.inlineType ? { inlineType: ta.inlineType as any } : {})}
                        className={`h-auto ${formSettings.formsize.value || ''} ${formSettings.borderradius.value || ''} ${formSettings.bordertype.value || ''} ${formSettings.bordercolor.value || ''}`.trim()}
                    />
                )
            }

            case 'RichText': {
                const rt = child as any
                return (
                    <RhyBusRichText
                        inputProps={{ id: rt?.id ? `richtext-${rt.id}` : 'LabelName' }}
                        label={rt?.label || 'Label Name'}
                        placeholder={rt?.placeholder || (rt?.label ? `Enter ${rt.label}` : '')}
                        isMandatory={rt?.isMandatory ?? false}
                        {...(rt?.isInfo && rt?.label ? { info: rt.label } : {})}
                        {...(rt?.hint ? { hint: rt.hint } : {})}
                        formClassName="form-vertical"
                    />
                )
            }

            case 'check':
                return <RhyBusInputCheck
                    id={child?.id ? `inputcheck-${child.id}` : 'LabelName'}
                    name={child?.type ? child?.type : 'radio'}
                    label={child?.label ? child?.label : 'Label Name'}
                    type='radio'
                    className='me-1 color-primary'
                    isMandatory={child?.isMandatory ? child?.isMandatory : false}
                />
            case 'uploadfile': {
                const fu = child as any
                return (
                    <RhyBusFileUpload
                        label={fu?.label || 'Attach File(s)'}
                        mandatory={fu?.isMandatory ?? false}
                        disabled={fu?.disabled ?? false}
                        labelClassName=""
                        {...(fu?.isInfo && fu?.label ? { info: fu.label, tooltipPlacement: (fu?.position || 'top') as any } : {})}
                        hint={fu?.hint || buildUploadHint(fu?.acceptedTypes, fu?.maxFileSizeMB, fu?.maxFiles)}
                        note={fu?.note || 'Screenshots need to be saved locally before uploading into system.'}
                        {...(fu?.chooseFileLabel ? { chooseFileLabel: fu.chooseFileLabel } : {})}
                        {...(fu?.maxFiles != null ? { maxFiles: fu.maxFiles } : {})}
                        {...(fu?.maxFileSizeMB != null ? { maxFileSize: fu.maxFileSizeMB } : {})}
                        {...(fu?.acceptedTypes ? { acceptedTypes: fu.acceptedTypes.split(',').map((s: string) => s.trim()).filter(Boolean) } : {})}
                        {...(fu?.removeMessage ? { removeMessage: fu.removeMessage } : {})}
                        {...(fu?.replaceMessage ? { replaceMesage: fu.replaceMessage } : {})}
                        {...(fu?.isBadge ? { isBadge: true, count: 0 } : {})}
                        {...(fu?.maxCount != null ? { maxCount: fu.maxCount } : {})}
                        {...(fu?.inline ? { inline: fu.inline } : {})}
                        {...(fu?.inlineType ? { inlineType: fu.inlineType as any } : {})}
                    />
                )
            }
            case 'Button':
                return (
                    <div className={`${getButtonColClass((child as any)?.buttonPosition)} w-100 h-100`}>
                    <div className={`${getButtonPositionClass((child as any)?.buttonPosition) || (child?.subChild?.length > 0 ? 'd-flex' : '')} ${child?.subChild?.length > 0 ? 'align-items-center gap-2 flex-wrap' : ''}`.trim()}>
                        <RhyBusButton
                            id={child?.id}
                            label={child?.label}
                            aria-label={child?.label}
                            variant={((child as any)?.variant ?? 'primary') as any}
                            {...((child as any)?.color ? { color: (child as any).color as any } : {})}
                            {...(child?.size ? { size: child.size as any } : {})}
                            {...((child as any)?.buttonType ? { type: (child as any).buttonType as any } : {})}
                            {...((child as any)?.pill ? { pill: true } : {})}
                            disabled={(child as any)?.disabled ?? false}
                            leftIcon={child?.leftIcon || ''}
                            rightIcon={child?.rightIcon || ''}
                            buttonClassName={(child as any)?.buttonClassName ?? ''}
                        />
                        {child?.subChild && child?.subChild?.length > 0 && child?.subChild?.map((subChild: { id: any; type: any; label: any }) => (
                            <>
                                {(
                                    <RhyBusButton id={subChild?.id}
                                        label={subChild?.label}
                                        aria-label={subChild?.label}
                                        variant={((subChild as any)?.variant ?? 'primary') as any}
                                        {...((subChild as any)?.color ? { color: (subChild as any).color as any } : {})}
                                        {...((subChild as any)?.size ? { size: (subChild as any).size as any } : {})}
                                        {...((subChild as any)?.buttonType ? { type: (subChild as any).buttonType as any } : {})}
                                        {...((subChild as any)?.pill ? { pill: true } : {})}
                                        disabled={(subChild as any)?.disabled ?? false}
                                        leftIcon={(subChild as any)?.leftIcon || ''}
                                        rightIcon={(subChild as any)?.rightIcon || ''}
                                        buttonClassName={(subChild as any)?.buttonClassName ?? ''}
                                        onClick={(e: any) => {
                                            e.stopPropagation()
                                            setSelectedSubButtonId(subChild?.id)
                                            setSelectedSubChild(subChild?.id)
                                            setSelectedType(subChild?.type)
                                            setTimeout(() => {
                                                getChildSelects(subChild.id, dynamicContainerId, rowId, child?.id)
                                            }, 1000)
                                        }}
                                    />
                                )}
                            </>
                        ))}
                    </div>
                    </div>
                )

            case 'SectionHeader':
                return (
                    <div
                        tabIndex={0}
                        aria-label={child?.label}
                        className='w-100'
                        style={{ backgroundColor: '#EEF0FF', borderRadius: '6px', padding: '8px 12px' }}
                    >
                        {child?.label}
                    </div>
                )

            case 'ContractDurationHeader':
                return (
                    <div
                        className='d-flex align-items-center justify-content-between w-100'
                        style={{ backgroundColor: '#434D8A', borderTopLeftRadius: '9px', borderTopRightRadius: '9px', padding: '8px 16px' }}
                    >
                        {child?.label}
                        <RhyBusButton
                            variant="text"
                            label="Add"
                            leftIcon="icon-rb-add font-12 whitetext"
                            style={{ '--rb-btn-bg': '#fff' } as React.CSSProperties}
                        />
                    </div>
                )

            case 'SubSectionHeader':
                return (
                    <div
                        tabIndex={0}
                        aria-label={child?.label}
                        className='w-100'
                        style={{ backgroundColor: '#EFF7FF', color: '#004993', borderRadius: '6px', padding: '8px 12px' }}
                    >
                        {child?.label}
                    </div>
                )

            default:
                return <div>Unknown Component</div>
        }
    }
    const handleAddCheckBox = (child: { id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean; position: string; placeholder: string | null; readonly: boolean | null; disabled: boolean | null }, containerId: string, rowsId: string, childId: string) => {
        setContainersData((prevContainers: any) =>
            prevContainers.map((container: any) => {
                if (container?.id === containerId) {
                    return {
                        ...container,
                        rowData: container.rowData.map((existingRow: any) =>
                            existingRow.id === rowsId
                                ? {
                                    ...existingRow,
                                    childData: existingRow.childData.map((childItem: any) =>
                                        childItem.id === childId ? {
                                            ...childItem,
                                            subChild: [...(childItem.subChild || []), { ...child, id: generateUniqueId('subChild') }]
                                        }
                                            : childItem
                                    )
                                } : existingRow
                        )
                    }
                }
                return container
            })
        )
    }
    const handleCopyChild = (child: { id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean; position: string; placeholder: string | null; readonly: boolean | null; disabled: boolean | null, subChild?: any }, containerId: string, rowsId: string) => {
        const uniqueId = generateUniqueId('child')
        setContainersData((prevContainers: any) =>
            prevContainers.map((container: any) => {
                if (container.id === containerId) {
                    return {
                        ...container,
                        rowData: container.rowData.map((existingRow: any) => {
                            if (existingRow.id !== rowsId) return existingRow
                            const originalIndex = existingRow.childData.findIndex((c: any) => c.id === child.id)
                            const copiedChild = {
                                ...child,
                                id: uniqueId,
                                subChild: (child.subChild || []).map((sub: any) => ({
                                    ...sub,
                                    id: uniqueId
                                }))
                            }
                            const updatedChildData = [...existingRow.childData]
                            updatedChildData.splice(originalIndex + 1, 0, copiedChild)
                            return {
                                ...existingRow,
                                childData: updatedChildData
                            }
                        })
                    }
                }
                return container
            })
        )
    }
    const handleDeleteSubButton = (subChildId: string, parentChildId: string, containerId: string, rowsId: string) => {
        setContainersData((prevContainers: any) =>
            prevContainers.map((container: any) => {
                if (container.id !== containerId) return container
                return {
                    ...container,
                    rowData: container.rowData.map((existingRow: any) => {
                        if (existingRow.id !== rowsId) return existingRow
                        return {
                            ...existingRow,
                            childData: existingRow.childData.map((childItem: any) =>
                                childItem.id === parentChildId
                                    ? { ...childItem, subChild: (childItem.subChild || []).filter((sc: any) => sc.id !== subChildId) }
                                    : childItem
                            )
                        }
                    })
                }
            })
        )
        setSelectedSubButtonId(null)
        setSelectedSubChild(null)
    }

    const handleDeleteChild = (childId: string, containerId: string, rowsId: string) => {
        // Find the current index of the child being deleted
        const childIndex = props?.childrenData.findIndex((child: any) => child.id === childId)

        // Find the previous child to focus on it
        let previousChildId = null
        if (childIndex > 0) {
            previousChildId = props?.childrenData[childIndex - 1]?.id
        } else if (props?.childrenData.length > 1) {
            // If deleted child is first, focus on the next one
            previousChildId = props?.childrenData[1]?.id
        }

        // Delete the child
        setContainersData((prevContainers: any) =>
            prevContainers.map((container: any) => {
                if (container.id === containerId) {
                    return {
                        ...container,
                        rowData: container?.rowData?.map((existingRow: any) =>
                            existingRow?.id === rowsId
                                ? {
                                    ...existingRow,
                                    childData: existingRow?.childData?.filter((child: any) => child.id !== childId)

                                } : existingRow
                        )
                    }
                }
                return container
            })
        )

        // Focus on previous component
        if (selectedChildId === childId) {
            if (previousChildId) {
                // Focus on the previous/next child
                setSelectedChildId(previousChildId)
                handleSelectChild(previousChildId, containerId, rowsId)
            } else {
                // No other children, clear selection
                setSelectedChildId(null)
                setSelectChilds(null)
            }
        }
    }

    return (
        <div
            key={child.id}
            id={child.id}
            ref={ref}
            className={`child-item p-relative ${child.className || ''} ${rowId && (selectedLayout[rowId] ? `col-12 col-md-6 col-lg-${selectedLayout[rowId][index % selectedLayout[rowId].length] === 20
                ? `${selectedLayout[rowId][index % selectedLayout[rowId].length]}per`
                : selectedLayout[rowId][index % selectedLayout[rowId].length]
                }` : 'col-12')
                }
                 ${(selectedChildId === child.id && containerId === dynamicContainerId && selectedRowId === rowId) ? 'selected-column border-primary bgcolor-primary-light' : 'transparent-border'} ${(isDragging && child.id === selectedChildId) ? 'bgcolor-primary-light' : ''}`}
            onClick={(e) => {
                e.stopPropagation()
                handleSelectChild(child.id, dynamicContainerId, rowId)
                setSelectedChildLabel(child.type)
                setSelectedSubButtonId(null)
            }}
            style={{ cursor: 'grab' }}

        >
            {renderChildComponent(child)}
            {selectedChildId === child.id && (
                <div className="element-buttons p-absolute d-flex" style={{ zIndex: 10 }}>
                    {selectedChildLabel === 'Button' && (
                        <RhyBusButton
                            aria-label="Add"
                            leftIcon="icon-rb-add whitetext"
                            variant='ghost'
                            onClick={(e: any) => {
                                e.stopPropagation()
                                handleAddCheckBox(child, dynamicContainerId, rowId, child?.id)
                            }}
                            size='xs'
                        />

                    )}
                    {
                        <>
                            <RhyBusButton
                                aria-label="Copy"
                                leftIcon="icon-rb-copy whitetext"
                                variant='ghost'
                                onClick={(e: any) => {
                                    e.stopPropagation()
                                    handleCopyChild(child, dynamicContainerId, rowId)
                                }}
                               size='xs'
                            />
                            <RhyBusButton
                                aria-label="Delete"
                                leftIcon="icon-rb-trashbin whitetext"
                                variant='ghost'
                                onClick={(e: any) => {
                                    e.stopPropagation()
                                    if (selectedSubButtonId && child.type === 'Button') {
                                        handleDeleteSubButton(selectedSubButtonId, child.id, dynamicContainerId, rowId)
                                    } else {
                                        handleDeleteChild(child.id, dynamicContainerId, rowId)
                                    }
                                }}
                                size='xs'
                            />
                        </>
                    }
                </div>
            )}
        </div>
    )
}

export default DraggableChildComponent
